import { useState, useEffect } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import api from '../../api';

// РОП видит оборот/динамику (Дашборд, ОПиУ), но не бухгалтерскую ленту ДДС/категоризацию/
// правила/банк — это остаётся у админа и бухгалтера. Сделки/проекты переехали в отдельный
// пункт меню верхнего уровня «Проекты» (см. pages/Projects.js) — менеджеру в разделе
// «Финансы» после этого делать больше нечего, поэтому у него сюда доступа больше нет.
const TABS = [
  { to: '/finance', label: 'Дашборд', end: true, roles: ['admin', 'accountant', 'rop'] },
  { to: '/finance/control', label: 'Начисления и сверка', roles: ['admin', 'accountant'] },
  { to: '/finance/cashflow', label: 'ДДС', roles: ['admin', 'accountant'] },
  { to: '/finance/queue', label: 'Категоризация', counterKey: 'queue', roles: ['admin', 'accountant'] },
  { to: '/finance/pnl', label: 'ОПиУ', roles: ['admin', 'accountant', 'rop'] },
  { to: '/finance/rules', label: 'Правила', roles: ['admin', 'accountant'] },
  { to: '/finance/bank', label: 'Банк', roles: ['admin', 'accountant'] },
  { to: '/finance/balance', label: 'Баланс', roles: ['admin', 'accountant'] },
  { to: '/finance/odds', label: 'ОДДС', roles: ['admin', 'accountant'] },
  { to: '/finance/calendar', label: 'Платёжный календарь', roles: ['admin', 'accountant'] },
];

export default function FinanceLayout() {
  const { user } = useAuth();
  const [queueCount, setQueueCount] = useState(0);
  // CEO-дашборд — не по роли, а персонально (см. backend/src/services/ceoAccess.js).
  const tabs = [
    ...(user.can_view_ceo_dashboard ? [{ to: '/finance/dashboard', label: 'CEO-дашборд' }] : []),
    ...TABS.filter(t => t.roles.includes(user.role)),
  ];

  useEffect(() => {
    if (!['admin', 'accountant'].includes(user.role)) return;
    const load = () => api.get('/finance/cashflow/queue/count').then(r => setQueueCount(r.data.count)).catch(() => {});
    load();
    const interval = setInterval(load, 60000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      <div className="toolbar" style={{ marginBottom: 20 }}>
        {tabs.map(t => (
          <NavLink key={t.to} to={t.to} end={t.end} className={({ isActive }) => isActive ? 'btn-primary btn-sm' : 'btn-secondary btn-sm'}>
            {t.label}
            {t.counterKey === 'queue' && queueCount > 0 && (
              <span style={{ marginLeft: 6, background: '#e31e24', color: '#fff', borderRadius: 10, padding: '1px 7px', fontSize: 11 }}>
                {queueCount}
              </span>
            )}
          </NavLink>
        ))}
        {user.role === 'admin' && (
          <NavLink to="/references" className="btn-secondary btn-sm">Статьи ДДС</NavLink>
        )}
      </div>
      <Outlet />
    </div>
  );
}
